<template>
  <form
    ref="form"
    data-url="/organizations"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Seleccione la Organización</label>
          <app-input
            type="select"
            v-model="selected"
            :list="orgList"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5 v-html="$store.getters.getTag('1')"></h5>
      </legend>

      <div class="col-md-6">
        <div class="form-group">
          <label>Razón Social</label>
          <app-input
            type="text"
            v-model="inputs.org.name"
            :disabled="disabled"
            placeholder="Ingrese la Razón Social"
            :required="true"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Tipo de Identificación</label>
          <app-input
            type="select"
            v-model="inputs.org.taxid_type"
            v-on:change="
              onChangeTaxid('orgTaxid', inputs.org.taxid_type, inputs.org.taxid)
            "
            :required="true"
            :list="taxidTypeLists"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="inputs.org.taxid_type == 'ruc'">
        <div class="form-group">
          <label>RUC</label>
          <app-input
            type="text"
            v-model="inputs.org.taxid"
            :disabled="disabled"
            placeholder="Ingrese el RUC"
            :required="true"
            @keyup="
              () => {
                inputs.org.taxid = inputs.org.taxid.replace(/[^0-9]/g, '');
                onChangeTaxid(
                  'orgTaxid',
                  inputs.org.taxid_type,
                  inputs.org.taxid
                );
              }
            "
          />
        </div>
      </div>
      <div class="col-md-6" v-if="inputs.org.taxid_type == 'other'">
        <div class="form-group">
          <label>RUT, NIT, Etc.</label>
          <app-input
            type="text"
            v-model="inputs.org.taxid"
            :disabled="disabled"
            placeholder="Ingrese el RUT, NIT, Etc."
            :required="true"
            @keyup="
              () => {
                inputs.org.taxid = inputs.org.taxid.replace(/[^0-9]/g, '');
                onChangeTaxid(
                  'orgTaxid',
                  inputs.org.taxid_type,
                  inputs.org.taxid
                );
              }
            "
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Nombre Comercial</label>
          <app-input
            type="text"
            v-model="inputs.org.business_name"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Nombre Comercial"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Representante Legal</label>
          <app-input
            type="text"
            v-model="inputs.org.legal_representative"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Representante Legal"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Tipo de Identificación</label>
          <app-input
            type="select"
            v-model="inputs.org.lr_taxid_type"
            v-on:change="
              onChangeTaxid(
                'lrTaxid',
                inputs.org.lr_taxid_type,
                inputs.org.legal_representative_taxid
              )
            "
            :required="true"
            :list="lrTaxidTypeLists"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>C.I./N° identificación</label>
          <app-input
            type="text"
            v-model="inputs.org.legal_representative_taxid"
            :disabled="disabled"
            placeholder="Ingrese la C.I./N° identificación"
            :required="true"
            @keyup="
              () => {
                inputs.org.legal_representative_taxid =
                  inputs.org.legal_representative_taxid.replace(/[^0-9]/g, '');
                onChangeTaxid(
                  'lrTaxid',
                  inputs.org.lr_taxid_type,
                  inputs.org.legal_representative_taxid
                );
              }
            "
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Tipo de Entidad</label>
          <app-input
            type="select"
            v-model="inputs.org.organization_type"
            :required="true"
            :list="[
              { id: '', value: 'Seleccione una opción' },
              ...organizationTypeList,
            ]"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Pág. web</label>
          <app-input
            type="text"
            v-model="inputs.org.web"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la Pág. web"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>País</label>
          <app-input
            type="select"
            v-model="inputs.org.country_id"
            :list="[
              { id: '', value: 'Seleccione una opción' },
              ...this.$store.state.common.countries,
            ]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="inputs.org.country_id && provinceList.length <= 1"
      >
        <div class="form-group">
          <label>Ciudad</label>
          <app-input
            type="text"
            v-model="inputs.org.city"
            placeholder="Ingrese la Ciudad"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="provinceList.length > 1">
        <div class="form-group">
          <label>Provincia</label>
          <app-input
            type="select"
            v-model="inputs.org.province_id"
            :list="[
              { id: '', value: 'Seleccione una opción' },
              ...provinceList,
            ]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="provinceList.length > 1">
        <div class="form-group">
          <label>Ciudad</label>
          <app-input
            type="select"
            v-model="inputs.org.canton_id"
            :list="[{ id: '', value: 'Seleccione una opción' }, ...cantonList]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Teléfono</label>
          <app-input
            type="tel-input"
            v-model="inputs.org.phone"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Teléfono"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>E-mail</label>
          <app-input
            type="email"
            v-model="inputs.org.email"
            placeholder="Ingrese su E-mail"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Dirección</label>
          <app-input
            type="textarea"
            v-model="inputs.org.address"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la Dirección"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5 v-html="$store.getters.getTag('1.1')"></h5>
        <app-input
          type="radio-buttons"
          :list="confirm"
          v-model="inputs.check_1"
          :disabled="disabled"
        />
      </legend>
    </div>

    <div class="row" v-if="inputs.check_1">
      <div class="col-md-6">
        <div class="form-group">
          <label>Apoderado (Empresa o persona)</label>
          <app-input
            type="text"
            v-model="inputs.lr.legal_representative"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Apoderado"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Tipo de Identificación</label>
          <app-input
            type="select"
            v-model="inputs.lr.lr_taxid_type"
            v-on:change="
              onChangeTaxid(
                'attorneyTaxid',
                inputs.lr.lr_taxid_type,
                inputs.lr.legal_representative_taxid
              )
            "
            :required="true"
            :list="lrTaxidTypeLists"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>RUC/C.I./identificación</label>
          <app-input
            type="text"
            v-model="inputs.lr.legal_representative_taxid"
            :disabled="disabled"
            placeholder="Ingrese el RUC/C.I./identificación"
            :required="true"
            @keyup="
              () => {
                inputs.lr.legal_representative_taxid =
                  inputs.lr.legal_representative_taxid.replace(/[^0-9]/g, '');
                onChangeTaxid(
                  'attorneyTaxid',
                  inputs.lr.lr_taxid_type,
                  inputs.lr.legal_representative_taxid
                );
              }
            "
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Ciudad</label>
          <app-input
            type="select"
            v-model="inputs.lr.canton_id"
            :list="[{ id: '', value: 'Seleccione una opción' }, ...cantons]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Teléfono</label>
          <app-input
            type="tel-input"
            v-model="inputs.lr.phone"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Teléfono"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>E-mail</label>
          <app-input
            type="email"
            v-model="inputs.lr.email"
            placeholder="Ingrese su E-mail"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Dirección</label>
          <app-input
            type="textarea"
            v-model="inputs.lr.address"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la Dirección"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5 v-html="$store.getters.getTag('1.2')"></h5>
        <app-input
          type="radio-buttons"
          :list="confirm"
          v-model="inputs.check_2"
          :disabled="disabled"
        />
      </legend>
    </div>

    <div class="row" v-if="inputs.check_2">
      <div class="col-md-6">
        <div class="form-group">
          <label>Razón Social</label>
          <app-input
            type="text"
            v-model="inputs.fb.name"
            :disabled="disabled"
            placeholder="Ingrese la Razón Social"
            :required="true"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>RUC/C.I./identificación:</label>
          <app-input
            type="text"
            v-model="inputs.fb.taxid"
            :disabled="disabled"
            placeholder="Ingrese el RUC/C.I./identificación:"
            :required="true"
            @keyup="
              () => (inputs.fb.taxid = inputs.fb.taxid.replace(/[^0-9]/g, ''))
            "
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Nombre Comercial</label>
          <app-input
            type="text"
            v-model="inputs.fb.business_name"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Nombre Comercial"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Representante Legal</label>
          <app-input
            type="text"
            v-model="inputs.fb.legal_representative"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Representante Legal"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Tipo de Identificación</label>
          <app-input
            type="select"
            v-model="inputs.fb.lr_taxid_type"
            v-on:change="
              onChangeTaxid(
                'fbTaxid2',
                inputs.fb.lr_taxid_type,
                inputs.fb.legal_representative_taxid
              )
            "
            :required="true"
            :list="lrTaxidTypeLists"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>C.I./N° identificación</label>
          <app-input
            type="text"
            v-model="inputs.fb.legal_representative_taxid"
            :disabled="disabled"
            placeholder="Ingrese la C.I./N° identificación"
            :required="true"
            @keyup="
              () => {
                inputs.fb.legal_representative_taxid =
                  inputs.fb.legal_representative_taxid.replace(/[^0-9]/g, '');
                onChangeTaxid(
                  'fbTaxid2',
                  inputs.fb.lr_taxid_type,
                  inputs.fb.legal_representative_taxid
                );
              }
            "
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Ciudad</label>
          <app-input
            type="select"
            v-model="inputs.fb.canton_id"
            :list="[{ id: '', value: 'Seleccione una opción' }, ...cantons]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Teléfono</label>
          <app-input
            type="tel-input"
            v-model="inputs.fb.phone"
            :disabled="disabled"
            :required="true"
            placeholder="Ingrese el Teléfono"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>E-mail</label>
          <app-input
            type="email"
            v-model="inputs.fb.email"
            placeholder="Ingrese su E-mail"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Dirección</label>
          <app-input
            type="textarea"
            v-model="inputs.fb.address"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la Dirección"
          />
        </div>
      </div>
    </div>

    <div class="mt-5" v-if="!disabled">
      <button
        type="submit"
        class="btn btn-primary mr-2"
        @click.prevent="submit"
      >
        {{ $t("save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        org: {},
        accApp: {},
        lr: {},
        fb: {},
        check_1: 0,
        check_2: 0,
      },
      provinceList: [],
      cantonList: [],
      orgs: [],
      selected: null,
      orgTaxid: true,
      lrTaxid: true,
      attorneyTaxid: true,
      fbTaxid1: true,
      fbTaxid2: true,
      delayTimer: null,
      taxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ruc", value: "Nacional" },
        { id: "other", value: "Internacional" },
      ],
      lrTaxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ci", value: "Cédula de Identidad" },
        { id: "ruc", value: "RUC" },
        { id: "other", value: "Otros" },
      ],
      organizationTypeList: [
        { id: "private", value: "Entidad privada" },
        { id: "public", value: "Entidad pública" },
        { id: "other", value: "Otros" },
      ],
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },
  computed: {
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      return !["100", "112"].includes(this.status);
    },
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    orgList() {
      const tmp = [
        {
          id: null,
          value: "Nueva Organización",
        },
        ...this.orgs.map((item) => {
          return {
            id: item.id,
            value: item.name || item.business_name,
          };
        }),
      ];
      return tmp;
    },
    cantons() {
      return this.$store.getters.getCantons();
    },
    tags() {
      return this.$store.state.form.tags;
    },
  },
  watch: {
    "inputs.org.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
    },

    "inputs.org.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },

    "$store.state.common.countries": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },

    selected: function () {
      if (!this.selected) {
        this.inputs.org = {};
      } else if (this.selected != this.inputs.orgs) {
        const tmp = this.orgs.filter((item) => item.id == this.selected);
        this.inputs.org = tmp[0];
      }
    },
  },
  created() {
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      // if (!this.orgTaxid) {
      //   this.$toastr.e("(1) RUC no valido");
      //   return;
      // }
      if (
        ["ci", "ruc"].includes(this.inputs.org.lr_taxid_type) &&
        !this.lrTaxid
      ) {
        this.$toastr.e("(1) C.I./N° identificación no valido");
        return;
      }

      if (this.inputs.check_1) {
        if (
          ["ci", "ruc"].includes(this.inputs.lr.lr_taxid_type) &&
          !this.attorneyTaxid
        ) {
          this.$toastr.e("(1.1) RUC/C.I./identificación no valido");
          return;
        }

        this.inputs.lr.acc_app_id = this.$store.state.accreditation.id;
        this.inputs.lr.establishment_type = "LR";
      } else {
        this.inputs.lr.acc_app_id = null;
      }

      if (this.inputs.check_2) {
        if (
          ["ci", "ruc"].includes(this.inputs.fb.lr_taxid_type) &&
          !this.fbTaxid2
        ) {
          this.$toastr.e("(1.2) C.I./N° identificación no valido");
          return;
        }

        this.inputs.fb.acc_app_id = this.$store.state.accreditation.id;
        this.inputs.fb.establishment_type = "FB";
      } else {
        this.inputs.fb.acc_app_id = null;
      }

      this.inputs.org.accAppId = this.$store.state.accreditation.id;
      this.inputs.org.establishment_type = "G";

      this.save(this.inputs);
    },

    afterSuccess(response) {
      const { orgs, accApp, lr } = response.data;

      if (accApp.organization) {
        this.inputs.org = accApp.organization;
        this.selected = accApp.organization.id;
      }
      if (accApp.legal_representative) {
        this.inputs.lr = accApp.legal_representative;
        this.inputs.check_1 = 1;
      }
      if (accApp.foreign_body) {
        this.inputs.fb = accApp.foreign_body;
        this.inputs.check_2 = 1;
      }
      this.inputs.accApp = accApp;
      this.orgs = orgs;

      this.$store.state.accreditation.org = { ...accApp.organization };

      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.$store.dispatch("getPoliticalDivision");

      this.preloader = true;

      this.axiosGet(
        `/organizations/index?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            const { orgs, accApp } = response.data;

            if (accApp.organization) {
              this.inputs.org = accApp.organization;
              this.selected = accApp.organization.id;
            }
            if (accApp.legal_representative) {
              this.inputs.lr = accApp.legal_representative;
              this.inputs.check_1 = 1;
            }
            if (accApp.foreign_body) {
              this.inputs.fb = accApp.foreign_body;
              this.inputs.check_2 = 1;
            }
            this.inputs.accApp = accApp;
            this.orgs = orgs;

            this.$store.state.accreditation.org = { ...accApp.organization };
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    onChangeTaxid(origin, type, taxid) {
      this[origin] = false;
      if (taxid && ["ci", "ruc"].includes(type)) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          if (type == "ruc" && taxid.length != 13) {
            this.$toastr.e("El RUC debe tener 13 digitos");
            return;
          }
          // this.validateTaxid(origin, type, taxid);
        }, 1000);
      } else {
        this[origin] = true;
      }
    },
    validateTaxid(origin, type, taxid) {
      this.preloader = true;
      let url;
      if (origin == "orgTaxid") {
        url = `/register/users/validateRucOrg/${taxid}/${
          this.inputs.org.id == null ? 1 : 0
        }`;
      } else {
        if (type == "ci") {
          url = `/register/users/validate/${taxid}/${type}`;
        } else {
          url = `/register/users/validateRucPayment/${taxid}`;
        }
      }
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.$toastr.e(response.data.message);
            }

            this[origin] = response.data.validate;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
